<div class="container-filter" matMenuContent (click)="$event.stopPropagation()">
  <div class="filter-component">
    @if(currentTab.id == 1){ @for(ramo of ramos; track ramo) {
    <button class="expansion-filter" mat-menu-item [matMenuTriggerFor]="menu">
      <div class="expansion-div">
        <ng-icon name="heroChevronLeftMini" class="icon-expansion" />
        <ng-icon [name]="ramo.icon" class="expansion-icon-branch" />
        <span class="filter-text">
          {{ ramo.nome }}
          <ng-container *ngIf="getSubRamosCount(ramo.nome) as cnt">
            ({{ cnt }})
          </ng-container>
        </span>
      </div>
    </button>

    <mat-menu #menu="matMenu" class="container-menu" xPosition="before">
      <div
        class="container-filter__padding"
        matMenuContent
        (click)="$event.stopPropagation()"
      >
        <div class="item-filter">
          <div class="lista">
            @for(subRamo of subRamos[ramo.nome]; track subRamo){
            <div class="item" (click)="updateFiltroRamo(ramo.nome, subRamo.nome)">
              <div class="container-icon">
                <ng-icon [name]="subRamo.icon" class="icon-branch" />
                <span class="filter-text">{{ subRamo.nome }}</span>
              </div>
              <div class="container-checkbox">
                <mat-checkbox
                  color="primary"
                  [ngModel]="isRamoChecked(ramo.nome, subRamo.nome)"
                  (click)="$event.stopPropagation()"
                  (ngModelChange)="updateFiltroRamo(ramo.nome, subRamo.nome)" />
              </div>
            </div>
            }
          </div>
        </div>
      </div>
    </mat-menu>
    } } @if(currentTab.id != 1){
    <div class="container-filter__padding item-filter">
      <div class="lista">
        @for(subRamo of subRamos[capitalizeFirst(currentTab.id_string)]; track
        subRamo){
        <div class="item" (click)="updateFiltroRamo(capitalizeFirst(currentTab.id_string), subRamo.nome)">
          <div class="container-icon">
            <ng-icon [name]="subRamo.icon" class="icon-branch" />
            <span class="filter-text">{{ subRamo.nome }}</span>
          </div>
          <div class="container-checkbox">
            <mat-checkbox
              color="primary"
              [ngModel]="isRamoChecked(capitalizeFirst(currentTab.id_string), subRamo.nome)"
              (click)="$event.stopPropagation()"
              (ngModelChange)="updateFiltroRamo(capitalizeFirst(currentTab.id_string), subRamo.nome)" />
          </div>
        </div>
        }
      </div>
    </div>
    }
  </div>
</div>
